import _merge from 'lodash.merge'
import _cloneDeep from 'lodash.clonedeep'
import _debounce from 'lodash.debounce'
import _forEach from 'lodash.foreach'
import i18next from 'i18next'

import store from '@/store/store'
import router from '@/router'

import {
  VUEX_ORDERS_UPDATE_QUERY,

  VUEX_ORDERS_LIST_FETCH,
  VUEX_ORDERS_LIST_FETCH_SUCCESS,
  VUEX_ORDERS_LIST_FETCH_FAILURE,
  VUEX_ORDERS_LIST_GRID_ROWS_DELETE,

  VUEX_ORDERS_DETAIL_CREATE,
  VUEX_ORDERS_DETAIL_DUPLICATE,
  VUEX_ORDERS_DETAIL_REACTIVATE,

  VUEX_ORDERS_DETAIL_REFETCH,
  VUEX_ORDERS_DETAIL_FETCH,
  VUEX_ORDERS_DETAIL_FETCH_SUCCESS,
  VUEX_ORDERS_DETAIL_FETCH_FAILURE,

  VUEX_ORDERS_PRODUCTS_LOOKUP_UPDATE,
  VUEX_ORDERS_GRID_SET_SNAPSHOT,

  VUEX_ORDERS_DETAIL_GRID_ROWS_ADD,
  VUEX_ORDERS_DETAIL_GRID_ROWS_ADD_COMPLETE,
  VUEX_ORDERS_DETAIL_GRID_ROWS_UPDATE,
  VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE,
  VUEX_ORDERS_DETAIL_CLEAR_DELETE_PRODUCTS,

  VUEX_ORDERS_DETAIL_MARK_COMPLETE,
  VUEX_ORDERS_DETAIL_MARK_COMPLETE_CONFIRMED,
  VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE,
  VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE_CONFIRMED,

  VUEX_ORDERS_DETAIL_BATCH_UPDATE,
  VUEX_ORDERS_DETAIL_BATCH_UPDATE2,
  VUEX_ORDERS_DETAIL_BATCH_UPDATE_SUCCESS,
  VUEX_ORDERS_DETAIL_ADD_COMMENT,
  VUEX_ORDERS_DETAIL_GRID_REQUEST_CLEAR,

  VUEX_ORDERS_SET_SELECTED_COORDINATOR,
  VUEX_ORDERS_CLEAR_SELECTED_COORDINATOR,

  VUEX_ORDERS_SET_GRID_SETTINGS,
  VUEX_ORDERS_UPDATE_GRID_SETTINGS,
  VUEX_ORDERS_CONFIRMATION_LEAVE_PAGE,
  VUEX_ORDERS_DROP_PRODUCTS,

  VUEX_ORDERS_TRIGGER_WHOLESALE_QUANTITIES_CELL_REFRESH,
  VUEX_ORDERS_DETAIL_EXCEL_EXPORT,
  VUEX_ORDERS_STYLE_AUTOCOMPLETE_FETCH
} from '@/store/constants/models/orders'

import {
  VUEX_API_ORDER_FETCH,
  VUEX_API_ORDER_CREATE,
  VUEX_API_ORDER_DUPLICATE,
  VUEX_API_ORDER_DELETE,
  VUEX_API_ORDERS_REQUEST_FETCH,
  VUEX_API_ORDER_BATCH_UPDATE,
  VUEX_API_ORDERS_PRODUCTS_ADD,
  VUEX_API_ORDER_ADD_COMMENT,
  VUEX_API_ORDERS_PRODUCTS_DELETE,
  VUEX_API_ORDERS_DROP_PRODUCTS,
  VUEX_API_ORDER_EXCEL_EXPORT,
  VUEX_API_ORDER_STYLE_AUTOCOMPLETE_FETCH
} from '@/store/constants/api'

import {
  VUEX_GRID_REKEY,
  VUEX_GRID_ROWDATA_LOADING_START,
  VUEX_GRID_ROWDATA_LOADING_FINISH,
  VUEX_GRID_UPDATE_START,
  VUEX_GRID_UPDATE_SUCCESS,
  VUEX_GRID_UPDATE_FAILURE,
  VUEX_GRID_DELETE_START,
  VUEX_GRID_DELETE_SUCCESS,
  VUEX_GRID_DELETE_FAILURE,
  VUEX_GRID_REQUEST_SNAPSHOT
} from '@/store/constants/ui/grid'

import {
  VUEX_NOTIFICATIONS_FETCH
} from '@/store/constants/models/notifications'

import {
  VUEX_TOAST_SHOW
} from '@/store/constants/ui/toast'

import DataMiddleware from '@/components/_core/GridsCore/helpers/DataMiddleware'
import longWaitBlocker from '@/helpers/longWaitBlocker'
import checkUserPermissions from '@/mixins/checkUserPermissions'
import requestHelper from './requestHelper'
import { getTranslationMsgCodes } from '@/helpers/translationHelper'
import GridHelpers from '@/components/_core/GridsCore/helpers/GridHelpers'


// import { order } from 'skch_its_be_fe_shared/validation'

function calculateOrderEditable (order) {
  const status = order?.status
  let ret = false
  if (status === 'DRAFT') {
    ret = true
  }
  if (order.type === ITS__ORDERS__ORDER_TYPE__SAMPLE) {
    const sc = store.getters.isSampleCoordinator()
    if (sc.hasPerm) {
      if (status === 'SUBMITTED' || status === 'IN PROGRESS') {
        ret = true
      }
    }
  }
  if (order.type === ITS__ORDERS__ORDER_TYPE__PROMO) {
    const approver = store.getters.isApprover()
    const seniorApprover = store.getters.isSeniorApprover()
    if (seniorApprover.hasPerm) {
      if (order.orderApprovalStatus === 'REQUIRES APPROVER' || order.orderApprovalStatus === 'REQUIRES SENIOR') {
        ret = true
      }
    } else if (approver.hasPerm) {
      if (order.orderApprovalStatus === 'REQUIRES APPROVER') {
        ret = true
      }
    }
  }
  if (order.type === ITS__ORDERS__ORDER_TYPE__WHOLESALE) {
    ret = true
  }
  return ret
}

const state = {
  // processing
  updatingInformation: {}, // used to show if any of these API calls are still updating

  // API related
  agGridRequestData: {
    addProducts: [],
    updateProducts: [],
    statusChangeProducts: [],
    deleteProducts: []
  },

  order: {},
  orders: [],
  query: {},

  agGridRowDataListing: [],
  agGridRowData: [],
  agGridPatchIdentifier: {},
  // selectedCoordinator: null,
  orderProductsLookup: {},
  orderRowsAddedToggler: '',
  wholesaleQuantitiesCellToggler: Math.random(),

  orderDetailRefetchParams: '', // the parameters used to fetch this order deteail - sometimes need to trigger a refetch

  // indicators while updating: mark as complete, submit new sample
  markCompleteStatus: '',
  submitNewSampleStatus: '',
  markCompleteConfirmedToggler: '',

  // shared calculated fields
  orderIsEditable: false,

  selectedCoordinator: null,

  confirmationLeavePageToggler: null,

  //wholesale style autocomplete
  wholesaleStyleAutocompleteStatus: null,
  wholesaleStyleAutocomplete: []
}

const getters = {
  selectedSampleCoordinatorCodeOrders: (state, rootGetters, rootState) => {
    const allowCoordinatorChange = router.currentRoute.value.meta.allowCoordinatorChange
    const userCode = rootState.user.user?.userCode
    const selectedCoordinatorCode = state.selectedCoordinator?.coordinatorCode
    const isSeniorSampleCoordinator = rootGetters.isSeniorSampleCoordinator().hasPerm
    const isSampleCoordinator = rootGetters.isSampleCoordinator().hasPerm

    return (/* (selectedCoordinatorCode && selectedCoordinatorCode !== userCode) && */ (isSeniorSampleCoordinator || isSampleCoordinator) && allowCoordinatorChange)
      ? { data: { _options: { viewAsCoordinatorCode: selectedCoordinatorCode || userCode } } }
      : null
  }
}

const actions = {
  [VUEX_ORDERS_DROP_PRODUCTS]: async ({ state, dispatch, commit }, payload) => {
    // start
    await commit(VUEX_GRID_UPDATE_START)

    if (payload.rowData) {
      let dropProducts = []
      for (const obj of payload.rowData) {
        dropProducts.push(
          {
            identifier: obj.identifier
          }
        )
      }
      let finalPayload = [
        {
          dropProducts: dropProducts
        },
        {
          submit: true
        }
      ]

      const response = await dispatch(VUEX_API_ORDERS_DROP_PRODUCTS, {
        data: finalPayload,
        id: state.order._id,
        orderType: state.order.purpose,
        orderSubtype: state.order.type
      })
      if (response?.data?.message === 'Success') {
        ///
        commit(VUEX_GRID_UPDATE_SUCCESS)
      } else {
        commit(VUEX_GRID_UPDATE_FAILURE)
      }
      await commit(VUEX_ORDERS_DETAIL_GRID_REQUEST_CLEAR)
    } else {
      commit(VUEX_GRID_UPDATE_FAILURE)
      console.error('VUEX_ORDERS_LIST_GRID_ROWS_DELETE fail')
    }
  },

  [VUEX_ORDERS_LIST_GRID_ROWS_DELETE]: async ({ state, dispatch, commit }, payload) => {
    // start
    commit(VUEX_GRID_UPDATE_START)

    if (payload.rows) {
      let numberSuccess = 0
      for (const obj of payload.rows) {
        // all orderSubtype - PROMO or SAMPLE - say SampleOrder here  EXCEPT WHOLESALE, which should be WholesaleOrder
        let orderType = 'SampleOrder'
        if (router.currentRoute.value.meta.orderSubtype === ITS__ORDERS__ORDER_TYPE__WHOLESALE) {
          orderType = 'WholesaleOrder'
        }

        const order = state.orders.find(o => o._id === obj._id)

        const response = await dispatch(VUEX_API_ORDER_DELETE, {
          id: obj._id,
          orderType: orderType,
          orderSubtype: router.currentRoute.value.meta.orderSubtype
        })
        if (response?.data?.message === 'Success') {
          numberSuccess++

          const customer = order.customer
          dispatch(VUEX_TOAST_SHOW, {
            component: '_core/Toast/Toast_Message.vue',
            data: {
              type: 'success',
              title: i18next.t('orders:STORE.ORDERS.DELETE.SUCCEEDED'),
              message: `${customer.name} (${customer.id})`
            }
          })
        } else {
          console.error('VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE | err', response)
        }
      } // for
      if (numberSuccess === payload.rows.length) {
        commit(VUEX_GRID_UPDATE_SUCCESS)
      } else {
        commit(VUEX_GRID_UPDATE_FAILURE)
      }
      await commit(VUEX_ORDERS_DETAIL_GRID_REQUEST_CLEAR)
    } else {
      commit(VUEX_GRID_UPDATE_FAILURE)
      console.error('VUEX_ORDERS_LIST_GRID_ROWS_DELETE fail')
    }
  },

  [VUEX_ORDERS_LIST_FETCH]: async ({ state, rootState, getters, dispatch, commit }, payload) => {
    const orderType = payload?.orderType || router.currentRoute.value.meta.orderType
    const manageType = payload?.manageType || router.currentRoute.value.meta.manageType
    const orderSubtype = payload?.orderSubtype || router.currentRoute.value.meta.orderSubtype
    const userCode = rootState.user.user?.userCode
    const role = checkUserPermissions({ accessRequires: [{ permission: ITS__PERMISSION__ORDERS__PROMO_ORDERS }] }, store).rawPermissionsData[0]?.permission?.role || null

    let data = payload /* || state.query */
    data = _merge(data, {
      orderType,
      orderSubtype,
      data: requestHelper.getRequestObj({ manageType, role, userCode })
    }, getters.selectedSampleCoordinatorCodeOrders)

    commit(VUEX_ORDERS_UPDATE_QUERY, data)

    await dispatch(VUEX_GRID_ROWDATA_LOADING_START)
    return dispatch(VUEX_API_ORDERS_REQUEST_FETCH, data).then(response => {
      commit(VUEX_ORDERS_LIST_FETCH_SUCCESS, response.data)
      dispatch(VUEX_GRID_ROWDATA_LOADING_FINISH)

      dispatch(VUEX_GRID_REKEY)
      return response.data
    }).catch(error => {
      commit(VUEX_ORDERS_LIST_FETCH_FAILURE, error)
      dispatch(VUEX_GRID_ROWDATA_LOADING_FINISH)
      return null
    })
  },

  [VUEX_ORDERS_SET_SELECTED_COORDINATOR]: ({ state, commit, dispatch }, { coordinator, request }) => {
    commit(VUEX_ORDERS_SET_SELECTED_COORDINATOR, coordinator)

    if (!request) return

    dispatch(VUEX_ORDERS_LIST_FETCH, { payload: state.query })

    dispatch(VUEX_NOTIFICATIONS_FETCH, { notificationType: 'SampleOrderNotification', data: { orderType: 'SAMPLE' } })
  },

  [VUEX_ORDERS_CLEAR_SELECTED_COORDINATOR]: ({ commit }) => {
    commit(VUEX_ORDERS_CLEAR_SELECTED_COORDINATOR)
  },

  [VUEX_ORDERS_DETAIL_REFETCH]: async ({ dispatch, commit, state }) => {
    await commit(VUEX_ORDERS_DETAIL_REFETCH)

    let payload = state.orderDetailRefetchParams
    payload.refetch = true

    await dispatch(VUEX_ORDERS_DETAIL_FETCH, payload)
  },

  [VUEX_ORDERS_DETAIL_FETCH]: async ({ state, dispatch, commit, rootState }, payload) => {
    const manageType = payload?.manageType || router.currentRoute.value.meta.manageType

    await commit(VUEX_ORDERS_DETAIL_REFETCH)
    await commit(VUEX_ORDERS_DETAIL_FETCH, payload)

    await dispatch(VUEX_GRID_ROWDATA_LOADING_START)

    const orderRequest = {
      ...payload,
      data: {
        orderNumber: payload.id,
        ...requestHelper.getRequestObj({ manageType })
      }
    }

    return dispatch(VUEX_API_ORDER_FETCH, orderRequest).then(async response => {
      const data = response.data?.[0] || response.data

      await commit(VUEX_ORDERS_DETAIL_FETCH_SUCCESS, { data, rootState })
      await commit(VUEX_ORDERS_PRODUCTS_LOOKUP_UPDATE, data)

      return data
    }).catch(async error => {
      await commit(VUEX_ORDERS_DETAIL_FETCH_FAILURE, error)
    }).finally(async () => {
      await dispatch(VUEX_GRID_ROWDATA_LOADING_FINISH)

      // now rekey when done
      await dispatch(VUEX_GRID_REKEY)
    })
  },

  [VUEX_ORDERS_DETAIL_CREATE]: ({ dispatch, commit }, payload) => {
    return dispatch(VUEX_API_ORDER_CREATE, payload).then(async response => {
      await commit(VUEX_ORDERS_DETAIL_CREATE, response.data)
      return response.data
    }).catch(err => {
      throw err.data
    })
  },

  [VUEX_ORDERS_DETAIL_DUPLICATE]: ({ dispatch, commit }, payload) => {
    return dispatch(VUEX_API_ORDER_DUPLICATE, payload).then(async response => {
      await commit(VUEX_ORDERS_DETAIL_DUPLICATE, response.data)

      const customer = response.data.customer
      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        data: {
          type: 'success',
          title: i18next.t('orders:TOASTS.DUPLICATE_ORDER.SUCCESS.TITLE'), // 'Order Duplicated',
          message: `${customer.name} (${customer.id})`
        }
      })

      return response.data
    })
  },

  [VUEX_ORDERS_DETAIL_REACTIVATE]: ({ dispatch, commit }, payload) => {
    return dispatch(VUEX_API_ORDER_DUPLICATE, payload).then(response => {
      commit(VUEX_ORDERS_DETAIL_DUPLICATE, response.data)

      const customer = response.data.customer
      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        data: {
          type: 'success',
          title: i18next.t('orders:TOASTS.REACTIVATE_ORDER.SUCCESS.TITLE'), // Order Reactivated
          message: `${customer.name} (${customer.id})`
        }
      })

      return response.data
    })
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_ADD]: async ({ dispatch, commit }, payload) => {
    await commit(VUEX_ORDERS_DETAIL_GRID_ROWS_ADD, payload)
    let data = _cloneDeep(state.agGridRequestData)
    // let rows = data.addProducts

    // filter out a few properties
    let rows = data.addProducts.map(row => {
      //const { disabled, id, _id, ...filteredRow } = row
      const { disabled, ...filteredRow } = row
      return filteredRow
    })

    let finalPayload = {
      frontEnd: {
        type: 'add'
      },
      addProducts: rows
    }

    await commit(VUEX_GRID_UPDATE_START) // to get the status message faster because of debounce
    let res = await dispatch(VUEX_ORDERS_DETAIL_BATCH_UPDATE, finalPayload)
    return res
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_UPDATE]: async ({ dispatch, commit }, payload) => {
    await commit(VUEX_ORDERS_DETAIL_GRID_ROWS_UPDATE, payload)
    let data = _cloneDeep(state.agGridRequestData)
    let rows = data.updateProducts

    let finalPayload = {
      frontEnd: {
        type: 'update'
      },
      updateProducts: rows
    }
    await commit(VUEX_GRID_UPDATE_START) // to get the status message faster because of debounce
    dispatch(VUEX_ORDERS_DETAIL_BATCH_UPDATE, finalPayload)
  },
  [VUEX_ORDERS_DETAIL_BATCH_UPDATE]: (() => {
    // capture the original handler in a debounced fn
    const debounced = _debounce(
      async ({ state, dispatch, commit }, payload) => {
        await commit(VUEX_GRID_UPDATE_START)

        if (payload.updateProducts || payload.addProducts || payload.submit || payload.status) {
          let finalPayloadData = []

          if (payload.updateProducts) {
            const update = []
            _forEach(payload.updateProducts, obj => {
              update.push({ identifier: obj._id, properties: obj.patch }) //_id in this case is identifier
            })
            finalPayloadData.push({ updateProducts: update })
          }

          if (payload.addProducts) {
            const add = []
            _forEach(payload.addProducts, obj => add.push(obj))
            finalPayloadData.push({ addProducts: add })
          }

          if (payload.submit || payload.status) {
            finalPayloadData = payload
          }

          try {
            const res = await dispatch(VUEX_ORDERS_DETAIL_BATCH_UPDATE2, { data: finalPayloadData })
            commit(VUEX_GRID_UPDATE_SUCCESS)
            await commit(VUEX_ORDERS_PRODUCTS_LOOKUP_UPDATE, state.order)
            await commit(VUEX_ORDERS_DETAIL_GRID_REQUEST_CLEAR)

            if (payload.frontEnd?.type === 'add') {
              const add = payload.addProducts || []
              if (add.length === res.data.length) {
                await commit(VUEX_ORDERS_DETAIL_GRID_ROWS_ADD_COMPLETE, {
                  request: add,
                  response: res.data
                })
              } else {
                console.error('Request count does not match response count')

                /* dispatch(VUEX_TOAST_SHOW, {
                  component: '_core/Toast/Toast_Message.vue',
                  persist: true,
                  data: {
                    type: 'error',
                    message: `Error: Request count doesn't match response count.`
                  }
                }) */
              }
            }

            return res
          } catch (err) {
            commit(VUEX_GRID_UPDATE_FAILURE)
            console.error(err)
            throw err
          }
        } else {
          commit(VUEX_GRID_UPDATE_FAILURE)
          console.error('VUEX_ORDERS_DETAIL_BATCH_UPDATE fail')
          return false
        }
      },
      1500
    )

    // this is the actual action that Vuex will call:
    return (context, payload) => {
      // queue up the debounced work
      debounced(context, payload)
      // return the promise of the last invocation
      return debounced.flush()
    }
  })(),

  [VUEX_ORDERS_DETAIL_BATCH_UPDATE2]: async ({ state, dispatch, commit }, payload) => {
    const order = state.order

    const {
      id = order._id,
      orderType = order.purpose,
      orderSubtype = order.type,
      data
    } = payload

    // const ordersAction = data[0].addProducts ? 'VUEX_API_ORDERS_PRODUCTS_ADD' : 'VUEX_API_ORDER_BATCH_UPDATE'

    return await dispatch(VUEX_API_ORDER_BATCH_UPDATE, {
      data, id, orderType, orderSubtype
    }).then(response => {
      // update order in state
      commit(VUEX_ORDERS_DETAIL_BATCH_UPDATE_SUCCESS, data)
      return response
    }).catch(err => {
      return err
    })
  },

  [VUEX_ORDERS_DETAIL_ADD_COMMENT]: async ({ state, dispatch }, payload) => {
    const response = await dispatch(VUEX_API_ORDER_ADD_COMMENT, {
      data: payload,
      id: state.order._id,
      orderType: state.order.purpose,
      orderSubtype: state.order.type
    })
    return response
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE]: async ({ state, dispatch, commit }, payload) => {
    commit(VUEX_ORDERS_DETAIL_CLEAR_DELETE_PRODUCTS)

    // get rows
    await commit(VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE, payload.rows)
    let data = _cloneDeep(state.agGridRequestData)
    let rows = data.deleteProducts

    // start
    if (payload.useDeletingStatusInsteadOfUpdating) {
      commit(VUEX_GRID_DELETE_START)
    } else {
      commit(VUEX_GRID_UPDATE_START)
      longWaitBlocker.show()
    }


    if (rows) {
      // kill all frontEnd passed keys
      let finalPayloadData = []
      let deleteArr = []
      // let i = 1
      _forEach(rows, function (obj) {
        let finalObj = {
          'identifier': obj._id
        }
        deleteArr.push(finalObj)
      })

      let temp = {deleteProducts: deleteArr}

      finalPayloadData.push(temp)

      dispatch(VUEX_API_ORDERS_PRODUCTS_DELETE, {
        data: finalPayloadData,
        id: state.order._id,
        orderType: state.order.purpose,
        orderSubtype: state.order.type

      }).then(async response => {
        if (payload.useDeletingStatusInsteadOfUpdating) {
          commit(VUEX_GRID_DELETE_SUCCESS)
        } else {
          commit(VUEX_GRID_UPDATE_SUCCESS)
        }

        await commit(VUEX_ORDERS_DETAIL_GRID_REQUEST_CLEAR)
        longWaitBlocker.hide()

        //GridHelpers.mgThisArray[0].gridApi.refreshServerSide({ purge: true })

        // let toastMessage = `${rows.length} Item${rows.length > 1 ? 's' : ''} Deleted`
        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'success',
            message: i18next.t('orders:TOASTS.GRID_ROWS.DELETED', { count: rows.length }),
          }
        })

        // if (state.order.purpose === ITS__ORDERS__ORDER_REQUEST_TYPE__WHOLESALE) {
        //   GridHelpers.mgThisArray[0].refetchAndRekey()
        // }


      }).catch(err => {
        commit(VUEX_GRID_UPDATE_FAILURE)
        longWaitBlocker.hide()
        // GridHelpers.mgThisArray[0].gridApi.refreshServerSide({ purge: true })

        console.error('VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE | err', err)
        return err
      })
    } else {
      if (payload.useDeletingStatusInsteadOfUpdating) {
        commit(VUEX_GRID_DELETE_FAILURE)
      } else {
        commit(VUEX_GRID_UPDATE_FAILURE)
      }

      longWaitBlocker.hide()

      console.error('VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE fail')
    }
  },

  [VUEX_ORDERS_DETAIL_MARK_COMPLETE]: async ({ dispatch, commit }) => {

    await commit(VUEX_ORDERS_DETAIL_MARK_COMPLETE, 'submitting')

    let finalPayload = {
      data: [{
        markCompleted: true
      }]
    }

    await dispatch(VUEX_ORDERS_DETAIL_BATCH_UPDATE2, finalPayload).then(async response => {
      const payload = (response.status === 200) ? 'success' : 'error'

      await commit(VUEX_ORDERS_DETAIL_MARK_COMPLETE, payload)

      if (payload === 'success') {
        dispatch(VUEX_ORDERS_DETAIL_REFETCH)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'success',
            message: `Success`
          }
        })
      }
    }).catch(err => {
      commit(VUEX_ORDERS_DETAIL_MARK_COMPLETE, 'error')

      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        persist: true,
        data: {
          type: 'error',
          message: err || err.response.data.message || err.response
        }
      })
    })
  },

  [VUEX_ORDERS_DETAIL_MARK_COMPLETE_CONFIRMED]: async ({ commit }) => {
    await commit(VUEX_ORDERS_DETAIL_MARK_COMPLETE_CONFIRMED)
  },

  [VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE_CONFIRMED]: async ({ commit }) => {
    await commit(VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE_CONFIRMED)
  },

  [VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE]: async ({ dispatch, commit }, payload) => {
    longWaitBlocker.show()

    await commit(VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE, 'submitting')

    let finalPayload = {
      data: [{
        submit: true
      }]
    }

    if (payload && Array.isArray(payload)) {
      finalPayload = {
        data: [{
          submit: {
            skus: payload
          }
        }]
      }
    }

    try {
      const response = await dispatch(VUEX_ORDERS_DETAIL_BATCH_UPDATE2, finalPayload)
      const payload = (response.status === 200) ? 'success' : 'error'

      await commit(VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE, payload)

      if (payload === 'success') {
        longWaitBlocker.hide()

        dispatch(VUEX_ORDERS_DETAIL_REFETCH)

        dispatch(VUEX_TOAST_SHOW, {
          component: '_core/Toast/Toast_Message.vue',
          data: {
            type: 'success',
            message: `Success`
          }
        })

        // go to orders list if wholesale
        if (router.currentRoute?.value?.meta?.orderSubtype === ITS__ORDERS__ORDER_TYPE__WHOLESALE) {
          router.push('/orders/wholesale/active')
        }
      } else {
        longWaitBlocker.hide()

        if (response?.data?.errors.length > 0) {
          let responseMessage = response.data.errors
            .map(error => {
              // if has Plutos
              if (error.identifier) {
                return `${error.meta.style}/${error.meta.color}: ${getTranslationMsgCodes(error)}`
              } else {
                return getTranslationMsgCodes(error)
              }
            })
            .join('<br>')

          dispatch(VUEX_TOAST_SHOW, {
            component: '_core/Toast/Toast_Message.vue',
            persist: true,
            data: {
              type: 'error',
              title: i18next.t('msgCodes:ITS_FE_ERROR_ORDER_REJECTED.TITLE'), // Order Rejected',
              message: responseMessage
            }
          })
          return response
        }
      }
    } catch (err) {
      longWaitBlocker.hide()
      commit(VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE, 'error')

      return err
    }
  },

  [VUEX_ORDERS_GRID_SET_SNAPSHOT]: ({ commit }, payload) => {
    commit(VUEX_ORDERS_GRID_SET_SNAPSHOT, payload)
  },

  [VUEX_ORDERS_SET_GRID_SETTINGS]: ({ commit }, payload) => {
    commit(VUEX_ORDERS_SET_GRID_SETTINGS, payload)
  },

  [VUEX_ORDERS_UPDATE_GRID_SETTINGS]: ({ commit }, payload) => {
    commit(VUEX_ORDERS_UPDATE_GRID_SETTINGS, payload)
  },

  [VUEX_ORDERS_CONFIRMATION_LEAVE_PAGE]: ({ commit }, payload) => {
    commit(VUEX_ORDERS_CONFIRMATION_LEAVE_PAGE, payload)
  },

  [VUEX_ORDERS_TRIGGER_WHOLESALE_QUANTITIES_CELL_REFRESH]: ({ commit }) => {
    commit(VUEX_ORDERS_TRIGGER_WHOLESALE_QUANTITIES_CELL_REFRESH)
  },

  [VUEX_ORDERS_DETAIL_EXCEL_EXPORT]: async ({ state, dispatch }, payload) => {
    const response = await dispatch(VUEX_API_ORDER_EXCEL_EXPORT, payload)

    const status = (response.status === 200) ? 'success' : 'error'
    if (status === 'success') {
      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        // timeout: 2000,
        data: {
          type: 'success',
          message: i18next.t('orders:TOASTS.EXPORT_DOCUMENT.SUCCESS')
        }
      })
    } else {
      dispatch(VUEX_TOAST_SHOW, {
        component: '_core/Toast/Toast_Message.vue',
        // timeout: 2000,
        data: {
          type: 'error',
          message: err || err.response.data.message || err.response
        }
      })
    }
  },

  [VUEX_ORDERS_STYLE_AUTOCOMPLETE_FETCH]: async ({ commit, dispatch }, payload) => {
    await commit(VUEX_ORDERS_STYLE_AUTOCOMPLETE_FETCH, {
      data: [],
      label: 'pending'
    })
    const response = await dispatch(VUEX_API_ORDER_STYLE_AUTOCOMPLETE_FETCH, payload)
    commit(VUEX_ORDERS_STYLE_AUTOCOMPLETE_FETCH, {
      data: response?.data,
      label: 'finished'
    })
  }
}

const mutations = {
  [VUEX_ORDERS_DETAIL_REFETCH]: (state, data) => {
    // reset some states
    // don't clear on REFETCH, only clear on first fetch - because it looks cleaner because some aspects in the grid rely on state.order.properties...
    // see below: if (payload.refetch) {...
    // state.order = []

    state.orderIsEditable = calculateOrderEditable(state.order)
    state.markCompleteStatus = ''
    state.submitNewSampleStatus = ''
  },
  [VUEX_ORDERS_DETAIL_FETCH]: (state, payload) => {
    state.orderDetailRefetchParams = payload

    if (payload.refetch) {
      state.order = []
    }
  },

  [VUEX_ORDERS_UPDATE_QUERY]: (state, data) => {
    state.query = _merge(state.query, data)
  },

  [VUEX_ORDERS_DETAIL_CREATE]: (state, data) => {
    state.orders.push(data)
  },

  [VUEX_ORDERS_DETAIL_DUPLICATE]: (state, data) => {
    state.orders.push(data)
  },

  [VUEX_ORDERS_LIST_FETCH_SUCCESS]: (state, data) => {
    // nested data fetch
    // data = Array.isArray(data) ? data[0] : data
    if (data) {
      // data = Array.isArray(data.data) ? data.data : data
      state.agGridRowDataListing = DataMiddleware.convertOrdersToRowData(data)
      state.orders = data
    } else {
      state.orders = []
    }
  },

  [VUEX_ORDERS_DETAIL_FETCH_SUCCESS]: (state, { data, rootState }) => {
    let products = data.products
    if (!products) {
      products = data.skus
    }
    if (data) {
      state.agGridRowData = DataMiddleware.convertOrderToRowData(products, data, rootState.user.user)
      state.order = data
    } else {
      data = []
      state.order = []
    }

    state.orderIsEditable = calculateOrderEditable(data)
  },

  [VUEX_ORDERS_GRID_SET_SNAPSHOT]: (state, data) => {
    // state.agGridSnapshot = _cloneDeep(data)
    state.order.skus = []
    state.order.skus = _cloneDeep(data)
  },

  [VUEX_ORDERS_PRODUCTS_LOOKUP_UPDATE]: (state, data) => {
    state.orderProductsLookup = {}

    if (data.products?.length > 0) {
      data.products?.forEach(p => {
        state.orderProductsLookup[`${p.style}-${p.color}`] = true
      })
    }
  },

  [VUEX_ORDERS_DETAIL_FETCH_FAILURE]: state => {
    state.order = {}
    state.orderIsEditable = calculateOrderEditable(state.order)
  },

  [VUEX_ORDERS_LIST_FETCH_FAILURE]: state => {
    state.orders = []
    state.orderIsEditable = calculateOrderEditable(state.order)
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_ADD]: (state, data) => {
    // update store with new products
    if (!state.order.skus?.length) state.order.skus = []

    data.forEach(item => {
      state.order.skus.push(item)
    })

    state.agGridRequestData.addProducts = state.agGridRequestData.addProducts.concat(data)
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_UPDATE]: (state, data) => {
    data.map(item => {
      state.agGridRequestData.updateProducts.push(item)
    })
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_DELETE]: (state, data) => {
    data.map(item => {
      state.agGridRequestData.deleteProducts.push(item)
    })
  },

  [VUEX_ORDERS_DETAIL_CLEAR_DELETE_PRODUCTS]: (state) => {
    if (state.agGridRequestData) {
      state.agGridRequestData.deleteProducts = []
    }
  },

  [VUEX_ORDERS_DETAIL_GRID_REQUEST_CLEAR]: state => {
    Object.keys(state.agGridRequestData).forEach(item => {
      if (item !== 'patch') state.agGridRequestData[item] = []
    })
    state.agGridPatchIdentifier = {}
  },

  [VUEX_ORDERS_DETAIL_BATCH_UPDATE_SUCCESS]: (state, data) => {
    state.order = Object.assign(state.order, data[0].patch)
  },

  [VUEX_ORDERS_DETAIL_GRID_ROWS_ADD_COMPLETE]: (state, data) => {
    state.agGridPatchIdentifier = data
    // state.order = data
    state.orderRowsAddedToggler = Math.random()
  },

  [VUEX_ORDERS_DETAIL_MARK_COMPLETE]: (state, data) => {
    state.markCompleteStatus = data
  },

  [VUEX_ORDERS_DETAIL_MARK_COMPLETE_CONFIRMED]: state => {
    state.markCompleteConfirmedToggler = Math.random()
  },

  [VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE]: (state, data) => {
    state.submitNewSampleStatus = data
  },

  [VUEX_ORDERS_DETAIL_SUBMIT_NEW_SAMPLE_CONFIRMED]: state => {
    state.togglerWholesaleSubmitConfirmed = Math.random()
  },



  [VUEX_ORDERS_SET_SELECTED_COORDINATOR]: (state, data) => {
    state.selectedCoordinator = data
  },

  [VUEX_ORDERS_CLEAR_SELECTED_COORDINATOR]: state => {
    state.selectedCoordinator = null
  },

  [VUEX_ORDERS_SET_GRID_SETTINGS]: (state, data) => {
    state.gridSettings = data
  },

  [VUEX_ORDERS_UPDATE_GRID_SETTINGS]: (state, data) => {
    const newSettings = Object.assign(state.gridSettings, data)
    state.gridSettings = newSettings
  },

  [VUEX_ORDERS_CONFIRMATION_LEAVE_PAGE]: (state, data) => {
    state.confirmationLeavePageToggler = data
  },

  [VUEX_ORDERS_TRIGGER_WHOLESALE_QUANTITIES_CELL_REFRESH]: (state) => {
    state.wholesaleQuantitiesCellToggler = Math.random()
  },

  [VUEX_ORDERS_STYLE_AUTOCOMPLETE_FETCH]: (state, { data, label }) => {
    state.wholesaleStyleAutocomplete = data
    state.wholesaleStyleAutocompleteStatus = label
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
